import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

const TermsTriptychStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  marginLeft: '-16px',
  marginRight: '-16px',
  [theme.breakpoints.up('md')]: {
    marginLeft: '-5.5%',
    marginRight: '-5.5%'
  }
});

export const TermsTriptychStyled = styled(Box)(TermsTriptychStyle);
